/* global Swiper */
const spotlightSliders = document.querySelectorAll('.spotlight-slider');

spotlightSliders.forEach((slider) => {
    const deck = slider.closest('.stack-deck');
    const prevBtn = deck.querySelector('.slide-prev');
    const nextBtn = deck.querySelector('.slide-next');

    const updateButtons = (swiper) => {
        prevBtn.disabled = swiper.isBeginning;
        nextBtn.disabled = swiper.isEnd;
    };

    const swiper = new Swiper(slider, {
        loop: false,
        effect: 'creative',
        creativeEffect: {
            limitProgress: 2,
            prev: {
                translate: ['110%', 0, 0],
                opacity: 0,
            },
            next: {
                translate: ['-12px', '-12px', 0],
                opacity: 1,
            },
        },
        touchRatio: -1,
        keyboard: {
            enabled: true,
        },
        on: {
            init(swiper) {
                updateButtons(swiper);
                const slides = Array.from(swiper.slides);
                slides.forEach(s => { s.style.height = 'auto'; });
                const tallest = Math.max(...slides.map(s => s.scrollHeight));
                slides.forEach(s => { s.style.height = tallest + 'px'; });
                swiper.update();
            },
            slideChange(swiper) { updateButtons(swiper); },
        },
    });

    prevBtn.addEventListener('click', () => swiper.slidePrev());
    nextBtn.addEventListener('click', () => swiper.slideNext());
});
